// Using Tabler Icons - See TABLER_REFERENCE.md for all valid icons
// Tabler has excellent sports icon coverage with specific icons for each sport
const popularSports = [
  { id: 'soccer', name: 'Soccer', icon: 'IconBallFootball' },
  { id: 'basketball', name: 'Basketball', icon: 'IconBallBasketball' },
  { id: 'tennis', name: 'Tennis', icon: 'IconBallTennis' },
  { id: 'pickleball', name: 'Pickleball', icon: 'IconBallTennis' }, // No specific pickleball, use tennis
  { id: 'volleyball', name: 'Volleyball', icon: 'IconBallVolleyball' },
  { id: 'baseball', name: 'Baseball', icon: 'IconBallBaseball' },
  { id: 'american-football', name: 'American Football', icon: 'IconBallAmericanFootball' },
  { id: 'golf', name: 'Golf', icon: 'IconGolf' },
  { id: 'cricket', name: 'Cricket', icon: 'IconBallBaseball' }, // Similar to baseball
  { id: 'rugby', name: 'Rugby', icon: 'IconBallFootball' }, // Similar to football
  { id: 'hockey', name: 'Ice Hockey', icon: 'IconBallBaseball' }, // Generic ball
  { id: 'badminton', name: 'Badminton', icon: 'IconBallTennis' }, // Similar to tennis
  { id: 'table-tennis', name: 'Table Tennis', icon: 'IconBallTennis' },
  { id: 'swimming', name: 'Swimming', icon: 'IconSwimming' },
  { id: 'running', name: 'Running', icon: 'IconRun' },
  { id: 'cycling', name: 'Cycling', icon: 'IconBike' },
  { id: 'boxing', name: 'Boxing', icon: 'IconKarate' }, // Martial arts icon
  { id: 'mma', name: 'MMA', icon: 'IconKarate' },
  { id: 'squash', name: 'Squash', icon: 'IconBallTennis' },
  { id: 'padel', name: 'Padel', icon: 'IconBallTennis' },
  { id: 'lacrosse', name: 'Lacrosse', icon: 'IconTargetArrow' },
  { id: 'skiing', name: 'Skiing', icon: 'IconRun' }, // Generic activity
  { id: 'snowboarding', name: 'Snowboarding', icon: 'IconRun' },
  { id: 'surfing', name: 'Surfing', icon: 'IconSwimming' },
  { id: 'wrestling', name: 'Wrestling', icon: 'IconKarate' }
];

export default popularSports;
